import React from 'react'
import cx from 'classnames'
import ScrollAnimation from 'react-animate-on-scroll'

class HighlightSvg extends React.Component {
  constructor(props) {
    super(props)

    this.svgRef = React.createRef()
  }

  animatePathsIn(visible) {
    const { type } = this.props

    const paths = [].slice.call(
      this.svgRef.current.querySelectorAll('[data-svg="path"]')
    )

    return paths.map((path, index) =>
      setTimeout(function() {
        path.setAttribute('class', '-highlighted')
      }, index * (type === 'animatedMap' ? 13 : 100))
    )
  }

  render() {
    const { content, theme, type } = this.props

    return (
      <div className="text-center w-full" data-label="highlight-svg">
        <p className="screenreader">{content.svg.altText}</p>
        <ScrollAnimation
          animateIn="translate-y-fade animation-fast"
          animateOnce={true}
          afterAnimatedIn={function afterAnimatedIn(visible) {
            this.animatePathsIn(visible)
          }.bind(this)}
        >
          <div
            dangerouslySetInnerHTML={{ __html: content.svg.markup }}
            className={cx(theme.textFullColor, {
              'divider pb-32 mb-15': content.texts
            })}
            data-label={cx({
              'animated-svg-line-graph': type === 'animatedSvgLineGraph',
              'animated-svg-circle-graph': type === 'animatedSvgCircleGraph',
              'animated-map': type === 'animatedMap'
            })}
            ref={this.svgRef}
            aria-hidden="true"
          />
        </ScrollAnimation>

        {content.texts && content.texts.title && (
          <p className="text-18 font-condensed uppercase mb-10">
            {content.texts.title}
          </p>
        )}
        {content.texts && content.texts.content && (
          <p className="text-18 leading-normal font-bold">
            {content.texts.content}
          </p>
        )}
      </div>
    )
  }
}

export default HighlightSvg
